var _g, _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderThumbIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 53,
    viewBox: "0 0 36 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_109_433)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 28,
    height: 45,
    rx: 14,
    fill: "var(--deep-ocean)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 27,
    height: 44,
    rx: 13.5,
    stroke: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 19.5,
    r: 1.5,
    fill: "var(--light-mint)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 19.5,
    r: 1.5,
    fill: "var(--light-mint)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 25.5,
    r: 1.5,
    fill: "var(--light-mint)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 25.5,
    r: 1.5,
    fill: "var(--light-mint)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_109_433",
    x: 0,
    y: 0,
    width: 36,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_109_433",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderThumbIcon1);
export default __webpack_public_path__ + "static/media/SliderThumbIcon1.0e314ffc0c1ee242284cb62ded57b576.svg";
export { ForwardRef as ReactComponent };